import {
    createSelector
} from 'reselect';

export const rulesSelector = createSelector(state => state && state.automationRules && state.automationRules.rules, rulesSelector => rulesSelector);
export const newRuleSelector = createSelector(state => state && state.automationRules && state.automationRules.ruleToStore, newRuleSelector => newRuleSelector);
export const isEditSelector = createSelector(state => state && state.automationRules && state.automationRules.isEdit, isEditSelector => isEditSelector);
export const newOrdersSelector = createSelector(state => state && state.automationRules && state.automationRules.newOrders, newOrdersSelector => newOrdersSelector);

